interface SpecialNote {
  value: number;
  label: string;
}

// Absent
export const ABS = {
  value: -1,
  label: 'Abs',
} as const satisfies SpecialNote;
// Non evalué
export const NE = {
  value: -2,
  label: 'NE',
} as const satisfies SpecialNote;
